import ModalTerms from "./ModalTerms.js";
export default ModalTerms;
